import { getInstalledApps } from 'InstalledApps.util';
import { useEffect, useState } from 'react';

/**
 * Determines if a given app is enabled for a company
 * @param  {string} appName   Name of an app
 * @return {bool}
 */

interface UseIsAppInstalledResult {
	isInstalled: boolean;
	isProcessingRequest: boolean;
}

export const useIsAppInstalled = (
	appName: string | string[],
): UseIsAppInstalledResult => {
	const [isInstalled, setIsInstalled] = useState(false);
	const [isProcessingRequest, setIsProcessingRequest] = useState(true);

	useEffect(() => {
		const checkAppInstalled = async () => {
			const installedApps = await getInstalledApps();
			const isArrayOfApps = Array.isArray(appName);

			if (isArrayOfApps) {
				setIsInstalled(appName.some((app) => installedApps.includes(app)));
			} else {
				setIsInstalled(installedApps.includes(appName));
			}

			setIsProcessingRequest(false);
		};

		checkAppInstalled();
	}, [appName]);

	return { isInstalled, isProcessingRequest };
};
